


import { Box, InputLabel, TextField } from "@mui/material";
import styles from './TitleEditor.module.scss';
import classNames from 'classnames/bind';
import { getUnit } from "@mui/material/styles/cssUtils";
import { getIn } from "formik";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { EditIcon, EditV1Icon, Pen3Icon } from "~/assets/icons";
import { useEffect, useRef, useState } from "react";

const cx = classNames.bind(styles);

const TitleEditor = (props: {
  name: string;
  form?: any;
  placeholder: string;
  inputkey: string;
  value?: string;
  disable?: boolean;
  onChange?: (e: any) => void;
  onEditModeChange?: (isEditing: boolean) => void;
  width?: string;
  restrictNumber?: boolean;
  height?: string;
  isViewMode?: boolean;
  errorMessage?: string;
  styleView?: any
}) => {
  const {
    name,
    form,
    placeholder,
    inputkey,
    value,
    onChange,
    onEditModeChange,
    disable,
    width,
    restrictNumber,
    height,
    isViewMode,
    errorMessage,
    styleView = {}
  } = props;


  const error = errorMessage ? errorMessage : getIn(form?.errors, inputkey);
  const [isEditMode, setEditMode] = useState(false);

  const [valueEdit, setValueEdit] = useState('');
  const spanRef = useRef<HTMLSpanElement>(null);
  const editRef = useRef<any>(null);
  const [inputWidth, setInputWidth] = useState(50);

  const updateEditMode = (editing: boolean) => {
    setEditMode(editing);
    if (onEditModeChange) {
      onEditModeChange(editing);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    let updatedValue = inputValue;

    if (restrictNumber) {
      updatedValue = inputValue.replace(/[^0-9]/g, "");
    }

    setValueEdit(updatedValue);
  };

  const handleCancel = () => {
    updateEditMode(false);
    setValueEdit(value !== undefined ? value : form?.values[inputkey])
  }

  const handleUpdate = () => {
    updateEditMode(false);

    if (onChange) {
      onChange(valueEdit);
    }

    if (form) {
      form.setFieldValue(inputkey, valueEdit);
    }
  }

  useEffect(() => {
    if (spanRef.current) {
      setInputWidth(spanRef.current.offsetWidth + 100); // + padding
    }
  }, [valueEdit]);

  useEffect(() => {
    if (isEditMode && editRef.current) {
      (editRef.current as any).focus();
    }
  }, [isEditMode, editRef]);

  if (!isEditMode || isViewMode) {
    return (
      <div className="flex items-center gap-[8px]">
        <p className={cx('text-view')} style={styleView}>{value !== undefined ? value : form?.values[inputkey]} </p>
        <div
          className="cursor-pointer"
          onClick={() => {
            updateEditMode(true);
            setValueEdit(value !== undefined ? value : form?.values[inputkey])
          }}>
          {
            !isViewMode && <Pen3Icon />
          }

        </div>
      </div>
    )
  }

  return (
    <Box className="">

      <span
        ref={spanRef}
        style={{
          position: 'absolute',
          visibility: 'hidden',
          whiteSpace: 'pre',
          fontSize: 16, // phải giống input
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 400,
        }}
      >
        {valueEdit || ' '}
      </span>

      {

        <Box
          className={cx({
            "box-form-input": true,
          })}

        >
          <TextField
            className={cx({
              "form-input": true,
            })}
            style={{
              width: inputWidth + "px",
            }}
            inputRef={editRef}
            name={name}
            placeholder={placeholder}
            value={valueEdit}
            onChange={handleInputChange}
            onBlur={handleUpdate}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleUpdate();
              }
            }}
            disabled={disable}
            error={Boolean(errorMessage)}
            helperText={errorMessage}
            sx={{
              "& .MuiInputBase-root": {
                minHeight: height ? height : "50px",
              },
              "& .MuiInputBase-root.MuiInputBase-multiline": {
                minHeight: height ? height : "150px",
                height: height ? height : "150px",
              }

            }}
          />

          <div className="flex items-center gap-[4px] ml-[8px]">
            <div onMouseDown={(e) => e.preventDefault()} onClick={handleCancel} className="cursor-pointer">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 8L8 20M8 8L20 20" stroke="#FA6363" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

            </div>
            <div onMouseDown={(e) => e.preventDefault()} onClick={handleUpdate} className="cursor-pointer">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 7L9.75 16L6 11.9091" stroke="#38B000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>
        </Box>
      }

    </Box>
  );
};

export default TitleEditor;
